var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTablet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "currentColor",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.813 9.375c-2.57 0-4.688 2.117-4.688 4.688v21.874c0 2.57 2.117 4.688 4.688 4.688h34.374c2.57 0 4.688-2.117 4.688-4.688V14.064c0-2.57-2.117-4.688-4.688-4.688H7.813Zm0 3.125h34.374c.868 0 1.563.695 1.563 1.563v21.874c0 .868-.695 1.563-1.563 1.563H7.813a1.557 1.557 0 0 1-1.563-1.563V14.064c0-.868.695-1.563 1.563-1.563Zm1.562 10.938c-.86 0-1.563.703-1.563 1.562 0 .86.704 1.563 1.563 1.563.86 0 1.563-.704 1.563-1.563 0-.86-.704-1.563-1.563-1.563Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablet);
export default __webpack_public_path__ + "static/media/tablet.37860dee19682ac40594a42c88f6c896.svg";
export { ForwardRef as ReactComponent };